@use '@/styles/tokens' as *;

/* No Figma frame covers this notice; every value is an existing token. It sits over live content, so
 * it carries its own card surface rather than borrowing the page's. */
.notice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-2);
  padding: var(--space-6);
  border: 0.5px solid var(--overlay-10);
  border-radius: 10px;
  background: var(--surface-card);
}

.noticeText {
  margin: 0;
  font-size: $font-size-sm;
  color: var(--text-muted);
}
